export enum EditionCGCMode {
  ADD_UNIT = 'ADD_UNIT',
  REASSIGN_UNIT = 'REASSIGN_UNIT',
}
